module.exports = __webpack_public_path__ + "img/no_filter_filled_64.16e718c0.svg";